export const getCurrentSession = (): string => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // 0 is January, 8 is September
    if (month >= 8) {
        return `${year}/${year + 1}`;
    } else {
        return `${year - 1}/${year}`;
    }
};

export const generateSessions = (startYear: number = 2024, count: number = 15): string[] => {
    return Array.from({ length: count }, (_, i) => {
        const year = startYear + i;
        return `${year}/${year + 1}`;
    });
};

export const generateUniqueId = (): string => {
    return Math.random().toString(36).substr(2, 9);
};

// Adds `days` WORKING days (Mon-Fri, matching this app's attendance-day convention —
// AttendanceStatus is only ever keyed monday..friday, no Saturday/Sunday) to `fromMs`,
// skipping weekends. School holidays from the Official Calendar are NOT factored in.
// Duplicated server-side in functions/src/index.ts rather than shared, matching this
// codebase's existing convention for small helpers used on both sides.
export const addWorkingDays = (fromMs: number, days: number): number => {
    const date = new Date(fromMs);
    let remaining = days;
    while (remaining > 0) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay(); // 0 = Sunday, 6 = Saturday
        if (day !== 0 && day !== 6) remaining--;
    }
    return date.getTime();
};

export type AttendanceDay = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

/**
 * Resolves active attendance days based on class/section name.
 * - Islamiyya section: 4 days (Monday, Tuesday, Wednesday, Thursday)
 * - Tahfiz section: 3 days (Thursday, Saturday, Sunday)
 * - Conventional / default: 5 days (Monday, Tuesday, Wednesday, Thursday, Friday)
 */
export const getSectionAttendanceDays = (
    classObjOrName?: any,
    sectionObjOrName?: any,
    allSections?: any[]
): AttendanceDay[] => {
    let nameToTest = '';

    if (typeof sectionObjOrName === 'string') {
        nameToTest += ' ' + sectionObjOrName;
    } else if (sectionObjOrName && typeof sectionObjOrName === 'object' && sectionObjOrName.name) {
        nameToTest += ' ' + sectionObjOrName.name;
    }

    if (typeof classObjOrName === 'string') {
        nameToTest += ' ' + classObjOrName;
    } else if (classObjOrName && typeof classObjOrName === 'object') {
        if (classObjOrName.name) nameToTest += ' ' + classObjOrName.name;
        if (classObjOrName.sectionId && Array.isArray(allSections)) {
            const sec = allSections.find(s => s.id === classObjOrName.sectionId);
            if (sec && sec.name) nameToTest += ' ' + sec.name;
        }
    }

    const lower = nameToTest.toLowerCase();

    if (lower.includes('tahfiz')) {
        return ['thursday', 'saturday', 'sunday'];
    }

    if (lower.includes('islamiyya')) {
        return ['monday', 'tuesday', 'wednesday', 'thursday'];
    }

    return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
};

